(function () {
  'use strict';
  const product = document.querySelector('.daluca-pdp--watch-strap');
  const root = product && (product.closest('.product-section') || product);
  const notice = document.querySelector('[data-daluca-qr-consent]');
  if (!root || !notice) return;
  const ack = notice.querySelector('[data-daluca-qr-ack]');
  const error = notice.querySelector('[data-daluca-qr-error]');
  let selectedKey = '';
  function selection() {
    const toggle = root.querySelector('[data-daluca-strap-upgrade-toggle][data-addon-key="quick-release"], [data-daluca-quick-release-toggle]');
    if (toggle) return {selected:toggle.checked, preserved:toggle.disabled && toggle.dataset.dalucaEditServicePreserved === 'true' && toggle.dataset.dalucaEditConsentValue === notice.dataset.value, host:toggle.closest('.daluca-master-addon-card-v366,.daluca-strap-upgrade, [data-daluca-quick-release]') || toggle.closest('label'), key:'upgrade'};
    const field = root.querySelector('[data-daluca-proxy-field="Quick Release"]');
    const native = Array.from(root.querySelectorAll('.gpo-app input, .gpo-app select')).filter(el => /quick[ -]?release/i.test([el.name,el.dataset.fieldName,el.dataset.name].join(' ')));
    const active = native.find(el => el.tagName === 'SELECT' ? !!el.value : el.checked);
    const value = String(active?.value || '');
    return {selected:!!value && !/^(no\b|none\b|standard\b|use\b|please\b|select\b)/i.test(value),host:field,key:value};
  }
  function sync() {
    const state = selection();
    if (selectedKey !== state.key || !state.selected) {ack.checked=false;error.hidden=true;}
    if (state.preserved) {ack.checked=true;error.hidden=true;}
    ack.disabled = !!state.preserved;
    selectedKey = state.key;
    if (state.host && state.host.nextElementSibling !== notice) state.host.after(notice);
    notice.hidden = !state.selected || !!state.preserved;
    root.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      let property = form.querySelector('[data-daluca-qr-property]');
      if (!property) {property=document.createElement('input');property.type='hidden';property.dataset.dalucaQrProperty='true';property.name='properties['+notice.dataset.property+']';form.append(property);}
      property.disabled = !state.selected || !ack.checked;
      property.value = notice.dataset.value;
    });
    return state.selected;
  }
  function validate() {
    if (!sync() || ack.checked) return true;
    window.DaLucaI18n.setText(error, notice.dataset.error);error.hidden=false;
    notice.scrollIntoView({block:'center',behavior:'smooth'});ack.focus({preventScroll:true});
    return false;
  }
  ack.addEventListener('change', () => {error.hidden=true;sync();});
  root.addEventListener('change',sync);
  document.addEventListener('daluca:cart-edit-services',sync);
  window.addEventListener('click',event => {
    const button=event.target.closest('.single-add-to-cart-button,.daluca-proxy-add-to-cart,button[name="add"],.shopify-payment-button__button');
    if (!button || !root.contains(button)) return;
    if (!validate()) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  window.addEventListener('submit',event => {
    if (root.contains(event.target) && event.target.matches('form[action*="/cart/add"]') && !validate()) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  let frame=0;
  new MutationObserver(changes=>{
    if(changes.every(change=>notice.contains(change.target)))return;
    if(!frame)frame=requestAnimationFrame(()=>{frame=0;sync();});
  }).observe(root,{subtree:true,childList:true});
  window.DaLucaQuickReleaseConsent={validate};
  sync();
})();



